module.exports = __webpack_public_path__ + "img/thumbnail_TasmanianDevil_j_normal.5776eb3c.png";